import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "DocumentMail" }

import { computed, PropType } from "vue";
import { Document, Mail } from "@/types";
import IconButton from "@/components/ds/icon-button/IconButton.vue";
import { dateToTimestamp } from "@/tools/date";
import { useDocumentsStore } from "@/stores/documents";
import api from "@/api";
import { useUiStore } from "@/stores/ui";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentMail',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const documentsStore = useDocumentsStore();
const uiStore = useUiStore();
const router = useRouter();

const mail = computed<Mail | undefined>(() => {
    return props.document.mails.length > 0 ? props.document.mails[0] : null;
});

const createMail = () => {
    const client = documentsStore.getClientForDocument(props.document);

    const mail = {
        id: 0,
        subject: "Factuur mbt " + props.document.title,
        content: "",
        user_id: props.document.user_id,
        receiver: "",
        date: dateToTimestamp(new Date()),
        mailType: "invoice",
        documentId: props.document.id,
        sent: false,
    };
    if (client) {
        mail.receiver = client.email;
    }
    if (client) {
        if (client.salutation) {
            mail.content = client.salutation + "\n";
        } else {
            mail.content = "Beste " + client.contactPerson + ",\n";
        }
        mail.content += "\n";
        mail.content +=
            "bijgaand de factuur mbt de werkzaamheden voor " +
            props.document.title +
            ".\n";
    }
    api.create(mail, "mails").then((response) => {
        mail.id = response.id;
        props.document.mails.push(mail);
        uiStore.message("Mail aangemaakt..");
        gotoMail(mail);
    });
};

const gotoMail = (mail: Mail) => {
    router.push({ name: "Mail", params: { id: mail.id } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (mail.value)
      ? (_openBlock(), _createBlock(IconButton, {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (gotoMail(mail.value))),
          "icon-id": "arrow-right"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Naar Mail: \"" + _toDisplayString(mail.value.subject) + "\" ", 1)
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(IconButton, {
          key: 1,
          "icon-id": "paper-plane",
          onClick: createMail
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Factuur mailen ")
          ])),
          _: 1
        }))
  ]))
}
}

})